
export function findDocumentos(){
  return documentos;
}

export default findDocumentos


const documentos = [
  [
    " Manual de Uso da Plataforma v0.2.6",
    "/img/baixar/DJ28 Manual de Uso da Plataforma v0.2.6.pdf"
  ],
  [
    "[MM] DESCRITIVO DO KIT Torre",
    "/img/baixar/[MM] MARATONINHA MAKER - DESCRITIVO DE KITS.pdf"
  ],
  [
    "[MM] DESCRITIVO DO KIT BÁSICO",
    "/img/baixar/[MM] MARATONINHA MAKER - DESCRITIVO DE KITS BÁSICO.pdf"
  ],
]
